import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Badge, Button, Card, Col, Divider, message, Row, Tabs } from 'antd';
import { queryTaskFiles, queryTaskInfo } from '@api/task';
import { BackBtn } from '@comm/BackBtn';
import Comment from '@comm/comment/Index';
import CardInfo from './CardTaskInfo';
import CardCompInfo from './CardCompInfo';

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabKey: '1',
      infoData: {},
    };
  }

  componentDidMount() {
    const { uuid } = this.props.params;
    this.loadInfo(uuid);
  }

  // 获取任务信息
  loadInfo = uuid => {
    queryTaskInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          infoData: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 获取任务附件
  loadFiles = uuid => {
    queryTaskFiles({ uuid }).then(res => {
      if (res.statusCode !== 200) {
        message.error(res.message);
      }
    });
  };

  getTaskFiles;

  changeTabs = key => {
    this.setState({
      tabKey: key,
    });
  };

  toPageSubmit = () => {
    const { infoData } = this.state;
    this.props.router.push(`/task/task_submit/${infoData.uuid}`);
  };

  toPageCheck = () => {
    const { infoData } = this.state;
    this.props.router.push(`/task/task_check_detail/${infoData.uuid}`);
  };

  render() {
    const { tabKey, infoData } = this.state;
    return (
      <div>
        <Card style={{ marginBottom: '0' }}>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <BackBtn />
              <span style={{ fontWeight: 'bolder', fontSize: '20px' }}>{infoData.name}</span>
            </Col>
            <Col>
              <Divider type="vertical" style={{ height: '30px' }} />
              <span style={{ fontSize: '18px', paddingRight: '15px' }}>
                任务目标 {infoData.aim || '-'}
              </span>
              <Divider type="vertical" style={{ height: '30px' }} />
              <span style={{ fontSize: '18px', paddingRight: '15px' }}>
                实际结果 {infoData.completionDate ? infoData.actual : '-'}
              </span>
              <Divider type="vertical" style={{ height: '30px' }} />
              <span style={{ fontSize: '18px', paddingRight: '15px' }}>
                {infoData.instance && infoData.instance.status === 0 ? (
                  <span>
                    <Badge color="yellow" />
                    审核中
                  </span>
                ) : (
                  <span>
                    {infoData.status === 1 && infoData.fettle === 1 ? (
                      <span>
                        <Badge color="red" />
                        已逾期
                      </span>
                    ) : null}
                    {infoData.status === 1 && infoData.fettle === 2 ? (
                      <span>
                        <Badge color="blue" />
                        进行中
                      </span>
                    ) : null}

                    {infoData.status === 1 && infoData.fettle === 3 ? (
                      <span>
                        <Badge status="default" />
                        未开始
                      </span>
                    ) : null}
                    {infoData.status === 2 && infoData.fettle === 1 ? (
                      <span>
                        <Badge color="red" />
                        未完成
                      </span>
                    ) : null}
                    {infoData.status === 2 && infoData.fettle === 2 ? (
                      <span>
                        <Badge color="green" />
                        已完成
                      </span>
                    ) : null}
                    {infoData.status === 2 && infoData.fettle === 3 ? (
                      <span>
                        <Badge status="default" />
                        已废弃
                      </span>
                    ) : null}
                  </span>
                )}
              </span>
              {infoData.status === 1 &&
              this.props.userInfo.userUuid === infoData.executives[0].userUuid &&
              !infoData.instance ? (
                <Button type="primary" style={{ marginRight: '20px' }} onClick={this.toPageSubmit}>
                  提交任务结果
                </Button>
              ) : (
                ''
              )}
              {infoData.instance && infoData.instance.status === 0 ? (
                <Button type="primary" style={{ marginRight: '20px' }} onClick={this.toPageCheck}>
                  查看审核流程
                </Button>
              ) : (
                ''
              )}
            </Col>
          </Row>
        </Card>
        <Tabs defaultActiveKey="1" activeKey={tabKey} onChange={this.changeTabs}>
          <TabPane tab="任务信息" key="1">
            <CardInfo data={infoData} />
          </TabPane>
          {infoData.completionDate ? (
            <TabPane tab="任务结果" key="2">
              <CardCompInfo data={infoData} />
            </TabPane>
          ) : null}
          <TabPane tab="任务评论" key="3">
            <Comment target={{ type: 'taskInfo', uuid: infoData.uuid }} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default connect(state => ({
  userInfo: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/task/spTask/pageDetail/Index.js